import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";
import { useLocale } from "@/contexts/LocaleContext";
import { DICTS } from "@/lib/i18n";
import { PUBLIC_SITE_ORIGIN } from "@/lib/public-origin";

import { publicCacheHeaders } from "@/lib/public-cache-headers";

export const Route = createFileRoute("/returns")({
  headers: publicCacheHeaders,
  head: () => ({
    meta: [
      { title: DICTS.en["legal.returns.meta.title"] },
      { name: "description", content: DICTS.en["legal.returns.meta.description"] },
      { property: "og:title", content: DICTS.en["legal.returns.meta.title"] },
      { property: "og:description", content: DICTS.en["legal.returns.meta.description"] },
      { property: "og:url", content: `${PUBLIC_SITE_ORIGIN}/returns` },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: `${PUBLIC_SITE_ORIGIN}/returns` }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Lecmo",
          url: PUBLIC_SITE_ORIGIN,
          hasMerchantReturnPolicy: {
            "@type": "MerchantReturnPolicy",
            "@id": `${PUBLIC_SITE_ORIGIN}/returns#policy`,
            merchantReturnLink: `${PUBLIC_SITE_ORIGIN}/returns`,
          },
        }),
      },
    ],
  }),
  component: ReturnsPage,
});

function ReturnsPage() {
  const { t } = useLocale();
  return (
    <LegalLayout titleKey="legal.returns.title" eyebrowKey="legal.returns.eyebrow">
      <p>{t("legal.returns.intro")}</p>
      <h2>{t("legal.returns.h2_no_returns")}</h2>
      <p>{t("legal.returns.p_no_returns")}</p>
      <h2>{t("legal.returns.h2_our_mistake")}</h2>
      <p>{t("legal.returns.p_our_mistake")}</p>
      <h2>{t("legal.returns.h2_how")}</h2>
      <p>{t("legal.returns.p_how")}</p>
      <h2>{t("legal.returns.h2_cancel")}</h2>
      <p>{t("legal.returns.p_cancel")}</p>
    </LegalLayout>
  );
}
